import DOMPurify from "dompurify";

/**
 * Securize html string to prevent from cross scripting
 * @param {*} dirty 
 * @returns 
 */
export function displayHtml(dirty){
    return { __html: DOMPurify.sanitize(dirty, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: ['allowfullscreen', 'target']
        }) 
    };
}

/**
 * Format number to be readable for the user
 * @param {*} number 
 * @returns 
 */
export function formatNumberDisplay(number) {
    return (
        parseInt(number, 10).toLocaleString('fr-FR', {
            useGrouping: true,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).replace(/\s/g, ' ')
    )
}

/**
 * Download file
 */
export function downloadFile(file, type, filename) {
    const byteCharacters = atob(file);
    // Convert file byte to byte
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: type });

    // Download file
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();    
}